import { render, staticRenderFns } from "./Line2slots.vue?vue&type=template&id=388e90e0&scoped=true&"
import script from "./Line2slots.vue?vue&type=script&lang=js&"
export * from "./Line2slots.vue?vue&type=script&lang=js&"
import style0 from "./Line2slots.vue?vue&type=style&index=0&id=388e90e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e90e0",
  null
  
)

export default component.exports